import { AdapterFactory } from '../AdapterFactory';

export const auditService = AdapterFactory.getAuditAdapter();
